import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import { team as teamService } from 'services';
import {
  getCustomTeamBaseMapTokenSuccess,
  getCustomTeamBaseMapTokenFailure,
  getTeamsListSuccess,
  getTeamsListFailure
} from './actions';
import { TeamActionTypes } from './types';

export function* handleGetCustomTeamBaseMapToken(request: any) {
  try {
    const response: AxiosResponse = yield call(
      teamService.generateTeamBaseMapToken,
      request.payload.key,
      request.payload.secret
    );
    if (response?.data) {
      yield put(getCustomTeamBaseMapTokenSuccess(response.data));
    } else {
      yield put(
        getCustomTeamBaseMapTokenFailure(
          'Cannot display the custom basemap. Please check custom basemap settings.'
        )
      );
    }
  } catch (error) {
    yield put(
      getCustomTeamBaseMapTokenFailure(
        'Cannot display the custom basemap. Please check custom basemap settings.'
      )
    );
  }
}

export function* handleGetTeamsList(request: any) {
  try {
    const response: AxiosResponse = yield call(
      teamService.getTeams,
      request.payload
    );
    if (response?.data) {
      yield put(getTeamsListSuccess(response.data));
    } else {
      yield put(getTeamsListFailure('Unable to fetch User Teams'));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(
      getTeamsListFailure(
        typeof msg === 'string' ? msg : 'Unable to fetch User Teams'
      )
    );
  }
}

export function* onGetCustomTeamBaseMapToken() {
  yield takeLatest(
    TeamActionTypes.GET_CUSTOM_TEAM_BASE_MAP_TOKEN_START,
    handleGetCustomTeamBaseMapToken
  );
}

export function* onGetTeamsList() {
  yield takeLatest(TeamActionTypes.GET_TEAMS_LIST_START, handleGetTeamsList);
}

export function* teamSagas() {
  yield all([call(onGetCustomTeamBaseMapToken), call(onGetTeamsList)]);
}

export default teamSagas;
